/* src/app/private/components/google-config/delete-google-config/delete-google-config.component.scss */
/*# sourceMappingURL=delete-google-config.component.css.map */
